export default __webpack_public_path__ + "static/media/todo.44c269d6.txt";